























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
@Component({
  components: {
    Sidebar: () => import('./components/sidebar.vue'),
    Topbar: () => import('./components/topbar.vue'),
    Breadcrumb: () => import('./components/breadcrumb.vue')
  }
})
export default class Layout extends Vue {
  private showBackTopBtn = false;
  private activated() {
    let el: any = document.querySelector('.wrapper-content');
    el.addEventListener('scroll', this.scrollToTop);
  }
  private scrollToTop() {
    let el: any = document.querySelector('.wrapper-content');
    this.showBackTopBtn = el.scrollTop > 300 ? true : false;
  }
  private backTop() {
    let el: any = document.querySelector('.wrapper-content');
    el.scrollTop = document.body.scrollTop = 0;
  }
}
